import React from 'react';
import DataGrid from './DataGrid';

const ReusableDataGrid = ({
    rows,
    columns,
    pageSize,
    page,
    rowCount,
    onPageChange,
    onPageSizeChange,
    pageSizeOptions = [5, 10, 25, 50],
    initialPageSize = 5,
    containerStyle = {},
    gridStyle = {},
    enablePagination = true,
    loading = false,
    error = null,
    loadingComponent = null,
    errorComponent = null,
    ...otherGridProps
}) => {
    const defaultContainerStyle = {
        width: '100%', 
        maxWidth: 'calc(100vw - 300px)', 
        height: '100%', // Use 100% height instead of fixed 400px
        overflow: 'auto', // Allow scrolling
        ...containerStyle
    };

    const defaultGridStyle = {
        '& .MuiDataGrid-root': {
            border: 'none',
            height: '100% !important', // Fill the container height
        },
        '& .MuiDataGrid-columnHeaders': {
            backgroundColor: '#f5f5f5',
        },
        '& .MuiDataGrid-virtualScroller': {
            overflowX: 'auto !important',
        },
        width: '100%',
        maxWidth: '100%',
        height: '100%', // Fill container height
        ...gridStyle
    };

    if (loading) {
        return (
            <div style={defaultContainerStyle}>
                {loadingComponent || <div style={{ textAlign: 'center', padding: '20px' }}>Loading...</div>}
            </div>
        );
    }

    if (error) {
        return (
            <div style={defaultContainerStyle}>
                {errorComponent || <div style={{ textAlign: 'center', padding: '20px', color: 'red' }}>Error loading data</div>}
            </div>
        );
    }

    const gridProps = {
        rows,
        columns,
        sx: defaultGridStyle,
        ...otherGridProps
    };

    if (enablePagination) {
        gridProps.pagination = true;
        gridProps.pageSize = pageSize;
        gridProps.page = page;
        gridProps.rowCount = rowCount;
        gridProps.onPageChange = onPageChange;
        gridProps.onPageSizeChange = onPageSizeChange;
        gridProps.pageSizeOptions = pageSizeOptions;
        gridProps.initialState = {
            pagination: { paginationModel: { pageSize: initialPageSize } },
        };
    }

    return (
        <div style={defaultContainerStyle}>
            <DataGrid {...gridProps} />
        </div>
    );
};

export default ReusableDataGrid;
